/**
 * meta中 role       为角色权限，决定用户是否有权限访问该路由
 * keepAlive        为缓存选项，如果该路由需要缓存，值设为true
 * requiresAuth     验证登录权限
 * title            页面标题
 */

import Nofound from '.././components/page/Nofound.vue'
import Iframe from '.././components/page/Iframe.vue'

// user    role:0
import Index from './../views/index.vue' // 首页
import jt_survey from './../views/jt_survey.vue' // 集团概况
import product_zx from './../views/product_zx.vue' // 产品中心
import product_zxinfo from './../views/product_zxinfo.vue' // 产品中心详情
import service_zc from './../views/service_zc.vue' // 服务支持
import contact_us from './../views/contact_us.vue' // 联系我们
import achievement_gk from './../views/achievement_gk.vue' // 业绩概况
import download_zx from './../views/download_zx.vue' // 下载中心
import news_zx from './../views/news_zx.vue' // 新闻资讯
import news_zxinfo from './../views/news_zxinfo.vue' // 新闻资讯详情

export default [
    // 内容的模板
    {
        path: '/',
        component: Iframe,
        meta: {
            requiresAuth: false
        },
        children: [
            // 首页
            {
                path: '/',
                name: 'home',
                component: Index,
                meta: {
                    requiresAuth: false,
                    title: '亿兴隆通风设备（河北）有限公司',
                    role: 0,
                    keepAlive: false
                }
            },
            // 集团概况
            {
                path: '/jt_survey',
                name: 'jt-survey',
                component: jt_survey,
                meta: {
                    requiresAuth: false,
                    title: '集团概况',
                    role: 0,
                    keepAlive: false
                }
            },
            // 产品中心
            {
                path: '/product_zx',
                name: 'product-zx',
                component: product_zx,
                meta: {
                    requiresAuth: false,
                    title: '产品中心',
                    role: 0,
                    keepAlive: true
                }
            },
            // 产品中心详情
            {
                path: '/product_zxinfo',
                name: 'product-zxinfo',
                component: product_zxinfo,
                meta: {
                    requiresAuth: false,
                    title: '产品中心详情',
                    role: 0,
                    keepAlive: false
                }
            },
            // 服务支持
            {
                path: '/service_zc',
                name: 'service-zc',
                component: service_zc,
                meta: {
                    requiresAuth: false,
                    title: '服务支持',
                    role: 0,
                    keepAlive: false
                }
            },
            // 联系我们
            {
                path: '/contact_us',
                name: 'contact-us',
                component: contact_us,
                meta: {
                    requiresAuth: false,
                    title: '联系我们',
                    role: 0,
                    keepAlive: false
                }
            },
            // 业绩概况
            {
                path: '/achievement_gk',
                name: 'achievement-gk',
                component: achievement_gk,
                meta: {
                    requiresAuth: false,
                    title: '业绩概况',
                    role: 0,
                    keepAlive: false
                }
            },
            // 下载中心
            {
                path: '/download_zx',
                name: 'download-zx',
                component: download_zx,
                meta: {
                    requiresAuth: false,
                    title: '下载中心',
                    role: 0,
                    keepAlive: false
                }
            },
            // 新闻资讯
            {
                path: '/news_zx',
                name: 'news-zx',
                component: news_zx,
                meta: {
                    requiresAuth: false,
                    title: '新闻资讯',
                    role: 0,
                    keepAlive: true
                }
            },
            // 新闻资讯详情
            {
                path: '/news_zxinfo',
                name: 'news-zxinfo',
                component: news_zxinfo,
                meta: {
                    requiresAuth: false,
                    title: '新闻资讯详情',
                    role: 0,
                    keepAlive: false
                }
            },
            // 其它404
            {
                path: '*',
                name: 'noaccess',
                component: Nofound,
                meta: {
                    requiresAuth: true,
                    pageTitle: '404'
                }
            }
        ]
    }
]
